import React, { useState } from "react";
import style from "./Details.module.scss";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import equipment from "../../../../../../images/v2/equipnent_placeholder.png";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import config from "../../../../../config";
const STRATUS_URL = config.paymentcloud.STRATUS_URL;

function Equipments({ appData, expandAppDetails }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`${style.accordion_item} ${expandAppDetails ? style.expanded : ""}`}
    >
      <div
        className={`${style.accordion_head} ${isOpen ? style.open : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <CaretDown24 />
        <h5>Equipment</h5>
      </div>
      {isOpen && (
        <div>
          {appData?.billing && appData?.ems_boot_equipments?.length > 0 && (
            <>
              <div className={style.accordion_body}>
                <div className={style.equipment_list}>
                  {appData?.ems_boot_equipments.map((eqp) => {
                    let equipment =
                      eqp?.equipment_option == "terminal"
                        ? eqp.terminal
                        : eqp.gateway;
                    let pricing_type = "";
                    if (eqp.purchase_for !== null) {
                      pricing_type = "Purchase";
                    } else if (eqp.rent_for !== null) {
                      pricing_type = "Rent";
                    } else if (eqp.lease_for !== null) {
                      pricing_type = "Lease";
                    } else if (eqp.tpp !== null) {
                      pricing_type = "TPP";
                    }

                    return (
                      <div className={style.equipment_item}>
                        <img
                          src={`${STRATUS_URL}get-image-by-path?path=${equipment.equipment_image}`}
                        />
                        <div className={style.eqp_data}>
                          <div className={style.eqp_heading}>
                            <span className={style.eqp_name}>
                              {equipment.equipment_name}
                              <span className={style.badge}>
                                {pricing_type}
                              </span>
                            </span>
                            <span className={style.eqp_name}>
                              X {eqp.quantity || 1}
                            </span>
                          </div>
                          <span className={style.desc}>
                            {eqp.equipment_option}
                          </span>
                        </div>
                      </div>
                    );
                  })}

                  {/* Addon */}
                  <div className={style.data_item}>
                    <p className={style.data_label}>Add-on</p>
                    <p className={style.data_value}>
                      Barcode Scanner, Impact Receipt Printer, Kitchen Display
                    </p>
                  </div>
                  {/* end addon */}
                </div>
              </div>
            </>
          )}

          {appData?.billing == null && (
            <>
              <HeadingWithLine
                text={
                  appData?.powerappequipment?.equipment_option == "terminal"
                    ? "Terminal"
                    : "Gateway"
                }
                className={style.heading_line}
              />
              <div className={style.accordion_body}>
                <div className={style.equipment_list}>
                  <div className={style.equipment_item}>
                    <img src={equipment} />
                    <div className={style.eqp_data}>
                      <div className={style.eqp_heading}>
                        <span className={style.eqp_name}>
                          {appData?.powerappequipment?.equipment_option ==
                          "terminal"
                            ? appData?.powerappequipment?.terminal
                                ?.equipment_name
                            : appData?.powerappequipment?.gateway
                                ?.equipment_name}
                        </span>
                      </div>
                      <span
                        className={style.desc}
                        style={{ textTransform: "capitalize" }}
                      >
                        {appData?.powerappequipment?.gateway_option?.replace(
                          "_",
                          " ",
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default Equipments;
